import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { db, auth } from './firebase';
import { 
    collection, query, where, onSnapshot, doc, 
    updateDoc, deleteDoc, serverTimestamp 
} from 'firebase/firestore';
import AppHeader from './AppHeader';
import { useNavigate } from 'react-router-dom';
import { FaCheck, FaTimes, FaUserCircle } from 'react-icons/fa';

const Container = styled.div`padding: 20px; max-width: 800px; margin: 20px auto; min-height: 100vh;`;
const Title = styled.h2`color: #1a73e8; margin-bottom: 25px; font-weight: 700;`;

const RequestCard = styled.div`
    background: white; padding: 20px; border-radius: 12px;
    display: flex; align-items: center; justify-content: space-between;
    margin-bottom: 15px; box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    border-left: 5px solid #1a73e8;

    @media (max-width: 600px) { flex-direction: column; align-items: flex-start; gap: 15px; }
`;

const UserInfo = styled.div`
    display: flex; align-items: center; gap: 15px;
    cursor: pointer; /* Clickable indicator */

    .icon { font-size: 45px; color: #dadce0; }
    .details { display: flex; flex-direction: column; }
    
    strong { 
        font-size: 17px; color: #1a73e8; text-decoration: none;
        &:hover { text-decoration: underline; }
    }
    span { font-size: 13px; color: #5f6368; }
`;

const ActionButtons = styled.div`display: flex; gap: 10px;`;
const Button = styled.button`
    padding: 10px 20px; border-radius: 25px; border: none;
    font-weight: 600; cursor: pointer; display: flex; align-items: center; gap: 8px;
`;
const AcceptBtn = styled(Button)`background: #1a73e8; color: white;`;
const RejectBtn = styled(Button)`background: #f1f3f4; color: #5f6368;`;

const Notifications = () => {
    const [requests, setRequests] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const user = auth.currentUser;
        if (!user) return;

        const q = query(
            collection(db, "connections"), 
            where("receiverId", "==", user.uid), 
            where("status", "==", "requested")
        );

        return onSnapshot(q, (snapshot) => {
            setRequests(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
        });
    }, []);

    const handleAction = async (id, action) => {
        try {
            const docRef = doc(db, "connections", id);
            if (action === 'accept') {
                await updateDoc(docRef, { status: 'connected', connectedAt: serverTimestamp() });
                alert("Connected!");
            } else {
                if(window.confirm("Reject request?")) await deleteDoc(docRef);
            }
        } catch (error) { console.error(error); }
    };

    return (
        <>
            <AppHeader />
            <Container>
                <Title>Notifications</Title>
                {requests.length === 0 ? (
                    <div style={{textAlign:'center', padding:'50px', background:'white', borderRadius:'12px'}}>No new requests.</div>
                ) : (
                    requests.map((req) => (
                        <RequestCard key={req.id}>
                            {/* Profile view-ku navigate seiyum area */}
                            <UserInfo onClick={() => navigate(`/profileview/${encodeURIComponent(req.senderFullName)}`)}>
                                <FaUserCircle className="icon" />
                                <div className="details">
                                    <strong>{req.senderFullName || "New User"}</strong>
                                    <span>Sent you a connection request</span>
                                </div>
                            </UserInfo>
                            <ActionButtons>
                                <AcceptBtn onClick={() => handleAction(req.id, 'accept')}><FaCheck /> Accept</AcceptBtn>
                                <RejectBtn onClick={() => handleAction(req.id, 'reject')}><FaTimes /> Reject</RejectBtn>
                            </ActionButtons>
                        </RequestCard>
                    ))
                )}
            </Container>
        </>
    );
};

export default Notifications;